import React from "react";
import { Lock } from "lucide-react";
import { useNavigate } from "react-router-dom";

export function TierGate({ tier = "alpha" }) {
  const navigate = useNavigate();
  const isAlpha = tier === "alpha";
  return (
    <div
      data-testid="tier-gate"
      className="relative rounded-2xl border border-[#ccff00]/30 bg-gradient-to-b from-[#0c0c0c] to-[#050505] p-10 text-center overflow-hidden grain"
    >
      <div className="relative z-10 flex flex-col items-center">
        <div className="w-14 h-14 rounded-full border border-[#ccff00]/40 flex items-center justify-center mb-4 glow-brand">
          <Lock className="w-6 h-6 text-[#ccff00]" />
        </div>
        <p className="font-mono-cl text-xs tracking-[0.24em] text-[#ccff00] uppercase mb-2">
          {isAlpha ? "Alpha Members Only" : "Members Only"}
        </p>
        <h3 className="font-display text-2xl sm:text-3xl font-bold mb-3">
          This is the deeper intelligence layer.
        </h3>
        <p className="text-zinc-400 max-w-md mb-6">
          {isAlpha
            ? "Full research, the interpretation layer, on-chain evidence and thesis tracking are reserved for Alpha members."
            : "Create a free account to unlock member commentary, watchlists and saved research."}
        </p>
        <div className="flex gap-3">
          {isAlpha ? (
            <button
              data-testid="gate-join-alpha"
              onClick={() => navigate("/pricing")}
              className="px-6 py-3 rounded-full bg-[#ccff00] text-black font-semibold text-sm hover:brightness-110 transition-[filter]"
            >
              Join Alpha
            </button>
          ) : (
            <button
              data-testid="gate-create-account"
              onClick={() => navigate("/register")}
              className="px-6 py-3 rounded-full bg-[#ccff00] text-black font-semibold text-sm hover:brightness-110 transition-[filter]"
            >
              Create Free Account
            </button>
          )}
          <button
            onClick={() => navigate("/pricing")}
            className="px-6 py-3 rounded-full border border-white/15 text-zinc-200 font-semibold text-sm hover:border-white/40 transition-colors"
          >
            See Membership
          </button>
        </div>
      </div>
    </div>
  );
}
